// ReportCatalogPanel — catalogo de relatorios previstos para um tema.
// Mostra o que o relatorio vai conter; nao ha geracao nem historico real ainda.
import { reportTypeIcons } from "@/config/relat-oper-ladm-relatorios-config";
import type { ReportCatalogItem } from "@/config/relat-oper-ladm-relatorios-config";

interface Props {
  title: string;
  items: ReportCatalogItem[];
}

export default function ReportCatalogPanel({ title, items }: Props) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((r) => (
          <div key={r.id} className="bg-white rounded-xl border border-background-200/70 p-4">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
                <i className={`${reportTypeIcons[r.type] || "ri-file-line"} text-primary-500 w-full h-full flex items-center justify-center text-lg`} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground-900 text-sm">{r.title}</h4>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{r.description}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {r.indicators.map((ind, i) => (
                <span key={i} className="text-xs bg-background-50 text-foreground-500 px-2 py-0.5 rounded border border-background-200">{ind}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
